// extracted by mini-css-extract-plugin
export default {"secondaryButton":"secondaryButton__m0Icy2","spinnerIcon":"spinnerIcon__h9Gr26"};